import { Button, Flex, Heading, Image, Text, VStack } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next/pages'

export const AffiliatePartnershipBanner = () => {
  const { t } = useTranslation()
  return (
    <Flex
      alignItems={'center'}
      justifyContent={{ base: 'center', md: 'flex-end' }}
      minH={{ base: '280px', sm: '300px', md: '260px', lg: '290px' }}
      w={'full'}
      maxW={'1000px'}
      mx={'auto'}
      rounded={'2xl'}
      bg={'ninja.600'}
      position={'relative'}
      overflow={'hidden'}
      px={{ base: 4, md: 6 }}
    >
      {/* Background image */}
      <Image
        src="/assets/images/partners/bg.webp"
        pos={'absolute'}
        alt=""
        w={'full'}
        h={'full'}
        objectFit={'cover'}
        inset={0}
      />
      {/* Rules image */}
      <Image
        src="/assets/images/partners/rules.png"
        pos={'absolute'}
        alt=""
        display={{ base: 'none', md: 'block' }}
        h={{ base: '95%', lg: '100%' }}
        w={'auto'}
        left={{ base: '0', lg: '30px' }}
        zIndex={5}
      />
      <Image
        src="/assets/images/partners/rules.png"
        pos={'absolute'}
        alt=""
        display={{ base: 'block', md: 'none' }}
        w={'auto'}
        h={{ base: '80%', sm: '85%' }}
        left={{ base: '-15px', sm: '5px' }}
        bottom={{ base: '-10px', sm: '-15px' }}
        opacity={{ base: 0.3, sm: 0.4 }}
        zIndex={1}
      />
      <VStack
        pos={'relative'}
        zIndex={10}
        align={{ base: 'center', md: 'flex-end' }}
        spacing={{ base: 3, md: 4 }}
        p={{ base: 4, sm: 5, md: 4, xl: 6 }}
        textAlign={{ base: 'center', md: 'right' }}
        maxW={{ base: '100%', md: 'auto' }}
      >
        <Heading
          lineHeight={1.2}
          fontSize={{ base: '20px', sm: '24px', md: '26px', lg: '32px' }}
          fontWeight={700}
          px={{ base: 2, md: 0 }}
        >
          {t('affiliate.partnership.title')}
        </Heading>

        <Text
          color={'ninja.100'}
          fontWeight={500}
          fontSize={{ base: 'xs', sm: 'sm', md: 'md' }}
          px={{ base: 2, md: 0 }}
          maxW={{ base: '90%', md: '100%' }}
        >
          {t('affiliate.partnership.description')}
        </Text>

        <Button
          as="a"
          href="https://t.me/alex_ninja_blaze"
          target="_blank"
          rel="noopener noreferrer"
          fontSize={{ base: '13px', md: '13px' }}
          px={{ base: 6, md: 7, lg: 8 }}
          h={{ base: '40px', md: '42px', lg: '44px' }}
          rounded={'xl'}
          colorScheme={'blue'}
          mt={{ base: 2, md: 2 }}
          _hover={{ transform: 'translateY(-2px)', boxShadow: 'lg' }}
          transition={'all 0.2s'}
          w={{ base: 'full', sm: 'auto' }}
          maxW={{ base: '280px', sm: 'auto' }}
        >
          {t('affiliate.partnership.contact-us')}
        </Button>
      </VStack>
    </Flex>
  )
}
